import { mergeTourData } from 'signer-app/context/signer-app-client/tour-local-storage-utils';
import * as tours from 'signer-app/context/signer-app-client/tours';

type Tours = typeof tours;

export default class MockTours implements Tours {
  async markTourAsCompletedOnBackend(_tour: string) {
    return true;
  }

  async isEligibleForTour(_tour: string) {
    return true;
  }

  async completeTour(tour: string, ops = { disableBackend: true }) {
    if (!ops.disableBackend) {
      this.markTourAsCompletedOnBackend(tour);
    }

    mergeTourData({
      [tour]: {
        completed: true,
      },
    });

    return {
      success: true,
    };
  }
}
